import './styles.scss'

import React from 'react'

export default function LoadingPlaceholder ({ style }) {
  return <div className='loading-placeholder' style={style} />
}
